<template>
  <div @click="toggleShare">
    <img src="../../../public/img/newPages/fenxiang.png" alt="" /><span
      >分享</span
    >
    <div
      class="social-share"
      data-sites="qzone, qq, weibo,wechat, douban"
      v-show="isShow"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      share: window._bd_share_main,
      isShow: false,
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.share ? this.share.init() : this.initShare()
    // })
    var $config = {
      // sites: ['qzone', 'qq', 'weibo','wechat', 'douban'],
      wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
      wechatQrcodeHelper:
        "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
    };

    socialShare(".social-share", $config);
  },
  methods: {
    initShare() {
      window._bd_share_config = {
        common: {
          bdSnsKey: {},
          bdText: "",
          bdMini: "2",
          bdPic: "",
          bdStyle: "0",
          bdSize: "16",
        },
        share: {},
        // selectShare: {
        //   bdContainerClass: null,
        //   bdSelectMiniList: ['tsina', 'weixin', 'sqq', 'qzone']
        // }
      };
      if (document.querySelector("#baidu")) {
        let share = document.querySelector("#baidu");
        document.body.removeChild(share);
      }
      const s = document.createElement("script");
      s.id = "baidu";
      s.src =
        window.location.protocol +
        "//bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=" +
        ~(-new Date() / 36e5);
      document.body.appendChild(s);
    },
    toggleShare() {
      this.isShow = !this.isShow;
    },
  },
};
</script>

<style lang="scss">
#bdshare_weixin_qrcode_dialog {
  height: 290px !important;
  top: 120px !important;
  left: 880px !important;
}
.toggles {
  cursor: pointer;
  span {
    color: #40ced3;
  }
}

.social-share {
  position: absolute;
  padding: 8px;
  right: 0px;
  bottom: -56px;
  background: rgb(255, 255, 255);
  z-index: 999;
  border-radius: 8px;
  .icon-wechat .wechat-qrcode {
    position: relative;
    top: 24px;
    left: -124px;
    display: none;
    &::after {
      content: "";
      position: absolute;
      left: 70%;
      margin-left: -6px;
      top: -14px;
      width: 0;
      height: 0;
      border-width: 8px 6px 6px 6px;
      border-style: solid;
      border-color: #fff transparent transparent transparent;
    }
  }
}
</style>

